import styled from 'styled-components'

import { Button } from '..'

const TextFieldWapper = styled(`div`)({
  display: 'flex',
  justifyContent: 'center',
  width: '95%',
  margin: `0 auto`,
})
export type ChatComponentProps = {
  sendMessage: () => void
  setMessage: (msg: string) => void
  message: string
}

export function TextInput({
  sendMessage,
  setMessage,
  message,
}: ChatComponentProps) {
  return (
    <TextFieldWapper>
      <input
        className="sq-input h-9"
        id="input_default"
        name="message"
        placeholder="メッセージを入力してください"
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <Button
        className="bg-blue-600 h-9"
        text="終了"
        size="m"
        square
        fill
        onClick={sendMessage}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#e8eaed"
        >
          <path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z" />
        </svg>
      </Button>
    </TextFieldWapper>
  )
}
